import "react-flags-select/scss/react-flags-select.scss";

import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";
import { deleteRatingCriterias, postRatingCriterias, pustRatingCriterias } from "../../store/middleware";

import { Prices } from "./styles";

function NewStudentRating() {
  let { id } = useParams();
  let { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    nameEnglish: "",
    namePortuguese: "",
    nameSpanish: "",
    nameFrench: "",
    descriptionEnglish: "",
    descriptionPortuguese: "",
    descriptionSpanish: "",
    descriptionFrench: "",
    target: "",
    active: false,
  });

  const getData = () => {
    if (id) {
      setForm({
        nameEnglish: state?.data?.nameEnglish,
        namePortuguese: state?.data?.namePortuguese,
        nameSpanish: state?.data?.nameSpanish,
        nameFrench: state?.data?.nameFrench,
        descriptionEnglish: state?.data?.descriptionEnglish,
        descriptionPortuguese: state?.data?.descriptionPortuguese,
        descriptionSpanish: state?.data?.descriptionSpanish,
        descriptionFrench: state?.data?.descriptionFrench,
        target: state?.data?.target,
        active: state?.data?.active,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setForm((state) => ({ ...state, [name]: newValue }));
  };

  const handlePost = () => {
    if (
      form.descriptionEnglish === "" ||
      form.descriptionPortuguese === "" ||
      form.descriptionSpanish === "" ||
      form.descriptionFrench === "" ||
      form.nameEnglish === "" ||
      form.namePortuguese === "" ||
      form.nameSpanish === "" ||
      form.nameFrench === ""
    )
      return;

    if (!id) {
      const body = {
        nameEnglish: form.nameEnglish,
        namePortuguese: form.namePortuguese,
        nameSpanish: form.nameSpanish,
        nameFrench: form.nameFrench,
        descriptionEnglish: form.descriptionEnglish,
        descriptionPortuguese: form.descriptionPortuguese,
        descriptionSpanish: form.descriptionSpanish,
        descriptionFrench: form.descriptionFrench,
        target: state?.data.toLowerCase(),
        active: form.active,
      };

      dispatch(postRatingCriterias(body)).then(() => navigate(-1));
    } else {
      dispatch(pustRatingCriterias(id, form)).then(() => navigate(-1));
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    dispatch(deleteRatingCriterias(id)).then(() => {
      navigate(-1);
      setOpen(false);
    });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header t={t} title="Rating" icon={<img src={Engrenagem} alt="Engrenagem" />} typeIcon="custom" />

        <div className="content">
          <Prices>
            <div className="bigBox teste">
              <h2>{!id ? `${state?.data} - Add new Criterion` : state?.data.nameEnglish}</h2>

              <div className="planInfo">
                <form className="formulario">
                  <h3>Name</h3>
                  <div>
                    <label htmlFor="gender">English</label>
                    <span>Required</span>
                  </div>
                  <input
                    name="nameEnglish"
                    onChange={handleChange}
                    value={form.nameEnglish}
                    placeholder="Enter criterion name"
                  />

                  <div>
                    <label htmlFor="gender">Português</label>
                    <span>Required</span>
                  </div>
                  <input
                    name="namePortuguese"
                    onChange={handleChange}
                    value={form.namePortuguese}
                    placeholder="Enter criterion name"
                  />

                  <div>
                    <label htmlFor="gender">Español</label>
                    <span>Required</span>
                  </div>
                  <input
                    name="nameSpanish"
                    onChange={handleChange}
                    value={form.nameSpanish}
                    placeholder="Enter criterion name"
                  />

                  <div>
                    <label htmlFor="gender">{t("FRENCH")}</label>
                    <span>Required</span>
                  </div>
                  <input
                    name="nameFrench"
                    onChange={handleChange}
                    value={form.nameFrench}
                    placeholder="Enter criterion name"
                  />

                  <h3>Description</h3>
                  <div>
                    <label htmlFor="gender">English</label>
                    <span>Required</span>
                  </div>
                  <input
                    onChange={handleChange}
                    name="descriptionEnglish"
                    value={form.descriptionEnglish}
                    placeholder="Description of the criterion"
                  />

                  <div>
                    <label htmlFor="gender">Português</label>
                    <span>Required</span>
                  </div>
                  <input
                    onChange={handleChange}
                    name="descriptionPortuguese"
                    value={form.descriptionPortuguese}
                    placeholder="Description of the criterion"
                  />

                  <div>
                    <label htmlFor="gender">Español</label>
                    <span>Required</span>
                  </div>
                  <input
                    onChange={handleChange}
                    name="descriptionSpanish"
                    value={form.descriptionSpanish}
                    placeholder="Description of the criterion"
                  />

                  <div>
                    <label htmlFor="gender">{t("FRENCH")}</label>
                    <span>Required</span>
                  </div>
                  <input
                    onChange={handleChange}
                    name="descriptionFrench"
                    value={form.descriptionFrench}
                    placeholder="Description of the criterion"
                  />

                  <label htmlFor="gender">Active?</label>
                  <div className="switchBox">
                    <div className="switch__container">
                      <input
                        name="active"
                        type="checkbox"
                        id="switch-shadow2"
                        checked={form.active}
                        onChange={handleChange}
                        className="switch switch--shadow"
                      />
                      <label htmlFor="switch-shadow2">
                        <span>{form.active ? "Yes" : "No"}</span>
                      </label>
                    </div>
                  </div>

                  {id && (
                    <Button onClick={() => setOpen(true)} className="deleteType">
                      Delete Language
                    </Button>
                  )}
                </form>
              </div>
            </div>
            <div className="button">
              <button className="back" onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>Back
              </button>
              <button className="save" onClick={handlePost}>
                Save
              </button>
            </div>
          </Prices>

          <Dialog
            open={open}
            keepMounted
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{"Please confirm"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {"Do you really want to remove the Rating " + form.nameEnglish + " ? "}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDelete} color="primary">
                {"Yes, delete"}
              </Button>
              <Button onClick={() => setOpen(false)} color="primary">
                {"Cancel"}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </section>
    </div>
  );
}

export default NewStudentRating;
